import { Box } from 'ui';

import { CurrencySelectField, type CurrencySelectFieldProps } from '../CurrencySelectField/CurrencySelectField';
import { TextField, type TextFieldProps } from '../TextField/TextField';

type PriceSlotProps = Pick<TextFieldProps, 'label' | 'name'> & Partial<Omit<TextFieldProps, 'label' | 'name' | 'type'>>;
type CurrencySlotProps = Partial<Omit<CurrencySelectFieldProps, 'sx'>>;

type Props = {
  'data-testid'?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  disabled?: boolean;
  slotProps: {
    currency?: CurrencySlotProps;
    price: Omit<PriceSlotProps, 'sx'>;
  };
};

export const PriceAndCurrencyField = ({
  fullWidth = true,
  size,
  disabled,
  'data-testid': dataTestId,
  slotProps,
}: Props) => {
  const { currency: currencySlotProps, price: priceSlotProps } = slotProps;

  return (
    <Box
      data-testid={dataTestId}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: fullWidth ? '100%' : undefined,
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          minWidth: '110px',
          mr: 0.5,
        }}
      >
        <CurrencySelectField name="currency" fullWidth={true} size={size} disabled={disabled} {...currencySlotProps} />
      </Box>
      <TextField type="number" fullWidth={fullWidth} size={size} disabled={disabled} {...priceSlotProps} />
    </Box>
  );
};
